import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-incident-list"
}
const _hoisted_2 = { class: "as-incident-list__head" }
const _hoisted_3 = {
  key: 0,
  class: "as-head-current"
}
const _hoisted_4 = { class: "as-match-time" }
const _hoisted_5 = { class: "as-match-status" }
const _hoisted_6 = {
  key: 1,
  class: "as-head-scores-round"
}
const _hoisted_7 = { class: "as-round-name" }
const _hoisted_8 = { class: "as-round-scores" }
const _hoisted_9 = {
  key: 0,
  class: "as-incident-list__body"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "as__left row_score" }
const _hoisted_12 = { class: "as__right row_score" }

import { ref, computed } from "vue";
import ArrowDown from "~src/components/icons/ArrowDown.vue";
import NoData from "~src/components/NoData.vue";
import IconVolleyball from "~src/components/icons/IconVolleyball.vue";
import type {
  IIncidentData,
  IIncidentRealTime,
  IRealTime,
} from "~src/interfaces/badminton";
import MatchEnum from "~src/enums/volleyball/MatchEnum";
import { formatLocalTime } from "~src/helpers/CommonHelper";


const __default__ = {};

interface IProps {
  incidents: IIncidentRealTime;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'IncidentsList',
  props: {
    incidents: {}
  },
  setup(__props: any) {

const props = __props;
const activeCollapse = ref("0");

const changeActiveCollapse = (index: any) => {
  if (activeCollapse.value === index) {
    activeCollapse.value = "";
  } else {
    activeCollapse.value = index;
  }
};

const processIncidents = (incidents: IIncidentData[], reverse: boolean = false) => {
  const _incidents = incidents
    .sort((a: IIncidentData, b: IIncidentData) => Number(a.set) - Number(b.set))
    .map((item: any) => {
      let _scores = item.scores;
      if (_scores) {
        _scores.map((score: IRealTime, index: number) => {
          let _class = "";
          let _prev = index - 1 < 0 ? 0 : index - 1;
          let point_active = '';

          if (index) {
            if (
              score.home_score == _scores[index - 1].home_score &&
              score.away_score > _scores[index - 1].away_score
            ) {
              _class = "as-away";
            }
          } else {
            if (score.away_score > score.home_score) {
              _class = "as-away";
            }
          }

          const current_home = _scores[index].home_score;
          const current_away = _scores[index].away_score;
          const prev_home = index > 0 ? _scores[_prev].home_score : 0;
          const prev_away = index > 0 ? _scores[_prev].away_score : 0;

          // point_active;
          if (current_home > prev_home && current_away == prev_away) {
            point_active = 'home';
          }

          if (current_home == prev_home && current_away > prev_away) {
            point_active = 'away';
          }

          score._class = _class;
          score.point_active = point_active;
          score.tie = Math.abs(score.home_score - score.away_score);
        });
      }
      return {
        ...item,
        scores: _scores.slice().reverse(),
      };
    });


    return reverse ? _incidents.reverse() : _incidents;
};

const rounds = computed(() => {
  const incidents = props.incidents.data;
  return processIncidents(incidents);
});

const rows = computed(() => {
  const incidents = props.incidents.data;

  return processIncidents(incidents, true);
});

const getLableTitle = (set: number | string) => {
  const text = MatchEnum.MATCH_STATUS_TEXT as { [key: string]: any };
  return text[set] ?? "FT";
};

const getLableIndex = (set: number | string, get_text = true) => {
  const text = {
    [MatchEnum.FIRST_SET.toString()]: 1,
    [MatchEnum.SECOND_SET.toString()]: 2,
    [MatchEnum.THIRD_SET.toString()]: 3,
    [MatchEnum.FOURTH_SET.toString()]: 4,
    [MatchEnum.FIFTH_SET.toString()]: 5,
  } as { [key: string]: any };

  if (get_text) {
    return text[set] ? `SET ${text[set]}` : "";
  } else {
    return text[set] ?? 0;
  }
};

const matchScores = computed(() => {
  return props.incidents.match?.scores ?? {};
});

const getScoresInMatch = (set: number | string) => {
  const index = getLableIndex(set, false);
  const value = matchScores.value[`p${index}`] || ["", ""];

  return value;
};


return (_ctx: any,_cache: any) => {
  return (_ctx.incidents.data?.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.incidents.match)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(formatLocalTime)(_ctx.incidents.match.match_time, "DD/MM/YYYY h:mm")), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(getLableTitle(_ctx.incidents.match.status_id)), 1)
              ]))
            : _createCommentVNode("", true),
          (rounds.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rounds.value, (incident, key) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "as-head-scores-round__items",
                    key: key
                  }, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(getLableTitle(incident.set)), 1),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["as-round-scores__as-home", {
                'as-win':
                  getScoresInMatch(incident.set)[0] >
                  getScoresInMatch(incident.set)[1],
              }])
                      }, _toDisplayString(getScoresInMatch(incident.set)[0]), 3),
                      _createElementVNode("div", {
                        class: _normalizeClass(["as-round-scores__as-away", {
                'as-win':
                  getScoresInMatch(incident.set)[0] <
                  getScoresInMatch(incident.set)[1],
              }])
                      }, _toDisplayString(getScoresInMatch(incident.set)[1]), 3)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (rows.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (incident, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "as-incident__item",
                  key: index
                }, [
                  _createElementVNode("h3", {
                    onClick: ($event: any) => (changeActiveCollapse(index.toString())),
                    class: _normalizeClass({
            'as-active': activeCollapse.value === index.toString(),
          })
                  }, [
                    _createElementVNode("span", null, _toDisplayString(getLableIndex(incident.set)) + ": " + _toDisplayString(getScoresInMatch(incident.set)[0]) + " - " + _toDisplayString(getScoresInMatch(incident.set)[1]), 1),
                    _createVNode(ArrowDown, { fill: "#4CF446" })
                  ], 10, _hoisted_10),
                  (incident.scores.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(incident.scores, (item, key) => {
                        return _withDirectives((_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(`as-incident_row ${item._class}`),
                          key: key
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(IconVolleyball)
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", {
                                class: _normalizeClass({
                'as-win': item.point_active === 'home',
              })
                              }, _toDisplayString(item.home_score), 3),
                              _cache[0] || (_cache[0] = _createTextVNode(" - ")),
                              _createElementVNode("span", {
                                class: _normalizeClass({
                'as-win': item.point_active === 'away',
              })
                              }, _toDisplayString(item.away_score), 3)
                            ]),
                            (item.tie)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: _normalizeClass(["match_history_row", {
              'as-green': item._class === 'as-away' && item.point_active === 'away',
            }])
                                }, "+" + _toDisplayString(item.tie), 3))
                              : _createCommentVNode("", true)
                          ])
                        ], 2)), [
                          [_vShow, activeCollapse.value == index.toString()]
                        ])
                      }), 128))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createBlock(NoData, { key: 1 }))
}
}

})